<hr>
<h2>Add Employee</h2>
<button class="cancel btn btn-warning" (click)="goBack()">Cancel</button>
<hr>
<div >
        <form name="form" [formGroup]="myForm" (ngSubmit)="addEmployee()" novalidate>
        <div class="form-group" >
            <label for="fname">First name</label>
                @if (myForm.get('fname')?.invalid) 
                {
                @if (fname?.errors?.['required']) {
                        <div class="help-block">
                            First Name is required.
                        </div>
                }
                @if (fname?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            First Name has too many characters.
                    </div>
                }
                }            
            <input type="text" class="form-control" id="fname" formControlName="fname" required />
        </div>
        <div class="form-group" >
                <label for="lname">Last name</label>
                                      @if (myForm.get('lname')?.invalid) 
            {
                @if (lname?.errors?.['required']) {
                        <div class="help-block">
                            Last Name is required.
                        </div>
                }
                @if (lname?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            Last Name has too many characters.
                    </div>
                }
            }            
                <input type="text" class="form-control" id="lname" formControlName="lname" required />
        </div>
        <div class="form-group" >
                <label for="employeecode">Employee Code (optional - autogenerated)</label>
                @if (myForm.get('employeecode')?.invalid) 
                {
                @if (employeecode?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            Employee Code has too many characters.
                    </div>
                }
                }            
                <input type="text" class="form-control" id="employeecode" formControlName="employeecode"  />
                
        </div>
        <div class="form-group">
            <button type="submit" [disabled]="myForm.invalid" class="btn btn-primary">Add</button>
        </div>
    </form>
</div>